export const setNextPageParam = (param) => (response, pages) => {
  if (response.lastPage <= pages.length) {
    return undefined
  }
  
  return { ...param, page : pages.length + 1 }
}
